export enum InconsistencyLevel {
  Minor = 'minor',
  Severe = 'severe',
  Critical = 'critical',
}

export enum InconsistencySource {
  MultipleDepositions = 'multipleDepositions',
  SameDeposition = 'sameDeposition',
  DepositionVsEvidence = 'depositionVsEvidence',
  EvidenceVsEvidence = 'evidenceVsEvidence',
}

export enum InconsistencyType {
  Dates = 'dates',
  Events = 'events',
  Evolving = 'evolving',
  Details = 'details',
  Observations = 'observations',
  Fabrications = 'fabrications',
}

export function getInconsistencySourceDisplayName(source: InconsistencySource): string {
  switch (source) {
    case InconsistencySource.MultipleDepositions:
      return 'Multiple Claims';
    case InconsistencySource.SameDeposition:
      return 'Same Claim';
    case InconsistencySource.DepositionVsEvidence:
      return 'Claim vs Evidence';
    case InconsistencySource.EvidenceVsEvidence:
      return 'Evidence vs Evidence';
  }
}

export function getInconsistencySourceTooltip(source: InconsistencySource): string {
  switch (source) {
    case InconsistencySource.MultipleDepositions:
      return 'This inconsistency was identified between across several different claims (i.e. between two depositions/witness statements).';
    case InconsistencySource.SameDeposition:
      return 'This inconsistency was identified within the same claim (i.e. the within one deposition/witness statement).';
    case InconsistencySource.DepositionVsEvidence:
      return 'This inconsistency was identified between a claim and evidence (i.e. a deposition/witness statement and a supporting document such as an email).';
    case InconsistencySource.EvidenceVsEvidence:
      return 'This inconsistency was identified between two or more different documents in the evidence (i.e. two emails).';
  }
}

export function getInconsistencyTypeTooltip(type: InconsistencyType): string {
  switch (type) {
    case InconsistencyType.Dates:
      return 'Conflicting timelines or dates of an event.';
    case InconsistencyType.Events:
      return 'Conflicting descriptions of an event by one or multiple people.';
    case InconsistencyType.Evolving:
      return 'A person changes their story over the course of their account.';
    case InconsistencyType.Details:
      return 'Discrepancies in the details of the claim.';
    case InconsistencyType.Observations:
      return 'Differing observations or interpretations of an event.';
    case InconsistencyType.Fabrications:
      return 'Significant changes in testimony that suggest deliberate deception.';
  }
}

export function getInconsistencyTypeDisplayName(type: InconsistencyType): string {
  switch (type) {
    case InconsistencyType.Dates:
      return 'Dates';
    case InconsistencyType.Events:
      return 'Conflicting Events';
    case InconsistencyType.Evolving:
      return 'Changing Testimony';
    case InconsistencyType.Details:
      return 'Conflicting Details';
    case InconsistencyType.Observations:
      return 'Observations';
    case InconsistencyType.Fabrications:
      return 'Possible Intentional Inconsistency';
  }
}
